<a ajsRouterLink="innhold.moete.sak" [ajsRouterLinkParams]="{id: sak().moete.id, sakId:sak().id}" class="gå-til-sak-lenke">
  <h2>
    <span class="nummmer">{{ sak().nummer }}</span>
    <span data-testid="sakstittel">{{ sak().tittel }}</span>
  </h2>
</a>

<div class="saksdetaljer">
  <h4>{{ 'Referat' | translate }}</h4>
  <html-formatert [innhold]="sak().referat" data-testid="referat"/>

  @if (beslutninger().length > 0) {
    <section>
      @if (beslutninger().length == 1) {
        <h4>{{ 'Beslutning' | translate }}</h4>
      } @else {
        <h4>{{ 'Beslutninger' | translate }}</h4>
      }
      @for (beslutning of beslutninger(); track beslutning.id) {
        <beslutning-listevisning-protokoll [beslutning]="beslutning" data-testid="beslutning"/>
      }
    </section>
  }

  @if (forslagTilBeslutninger().length > 0) {
    <div class="vis-skjul-beslutningsforslag ikke-print">
      @if (!viserForslagTilBeslutninger()) {
        <a (click)="visForslag()" data-testid="vis-beslutningsforslag-knapp">
          {{ 'Vis {antall} forslag til beslutninger' | translate:{antall: forslagTilBeslutninger().length} }}
        </a>
      } @else {
        <a (click)="skjulForslag()">
          {{ 'Skjul forslag til beslutninger' | translate }}
        </a>
      }
    </div>

    @if (viserForslagTilBeslutninger()) {
      <section class="beslutningsforslag">
        @for (beslutning of forslagTilBeslutninger(); track beslutning.id) {
          <beslutning-listevisning-protokoll [beslutning]="beslutning" visForslag="true"/>
        }
      </section>
    }
  }
</div>
